module.exports = __webpack_public_path__ + "static/stats@2x-aecaf5a98a61460c23584ebf810c29f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/case-studies/buzzfeed/stats@2x.jpg
// module id = 333
// module chunks = 3627797113349 20562973939449 33019919093843